import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { FaHome, FaGraduationCap, FaCalendarAlt, FaUserCog, FaSignOutAlt, FaBars, FaTimes } from 'react-icons/fa';
import './plataforma.css';

const LayoutPlataforma = ({ onLogout }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const navigate = useNavigate();

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleLogout = () => {
        if (onLogout) {
            onLogout();
        }
        navigate('/login');
    };

    const menuItems = [
        { path: '/plataforma', icon: <FaHome />, label: 'Início', end: true },
        { path: '/plataforma/cursos', icon: <FaGraduationCap />, label: 'Meus Cursos' },
        { path: '/plataforma/agendamentos', icon: <FaCalendarAlt />, label: 'Agendamentos' },
        { path: '/plataforma/conta', icon: <FaUserCog />, label: 'Minha Conta' },
    ];

    return (
        <div className="plataforma-layout">
            {/* Mobile Toggle Button */}
            <button className="mobile-toggle" onClick={toggleSidebar}>
                {isSidebarOpen ? <FaTimes /> : <FaBars />}
            </button>

            {/* Overlay for mobile */}
            {isSidebarOpen && (
                <div className="sidebar-overlay" onClick={() => setIsSidebarOpen(false)}></div>
            )}

            {/* Sidebar */}
            <aside className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
                <div className="sidebar-header">
                    <h2>Sulash</h2>
                    {/* Close button for mobile inside sidebar */}
                    <button className="mobile-close-btn" onClick={() => setIsSidebarOpen(false)}>
                        <FaTimes />
                    </button>
                </div>

                <nav className="sidebar-nav">
                    {menuItems.map((item) => (
                        <NavLink
                            key={item.path}
                            to={item.path}
                            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                            end={item.end}
                            onClick={() => setIsSidebarOpen(false)} // Close sidebar on mobile click
                        >
                            {item.icon}
                            <span>{item.label}</span>
                        </NavLink>
                    ))}
                </nav>

                <div className="sidebar-footer">
                    <button onClick={handleLogout} className="logout-btn">
                        <FaSignOutAlt />
                        <span>Sair</span>
                    </button>
                </div>
            </aside>

            {/* Main Content */}
            <main className="main-content">
                <Outlet />
            </main>
        </div>
    );
};

export default LayoutPlataforma;
